module.exports = __webpack_public_path__ + "media/images/avatar/11-d0e4694da2cb55eecf1b5880bb03c6f4.svg";